var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformatoareDeCurent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 82,
    viewBox: "0 0 76 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 26L26.1946 25.5688C23.911 25.5313 22.0597 27.4104 22.131 29.6932L22.3789 37.6249C22.4464 39.7844 24.2165 41.5 26.377 41.5L38 41.5",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 55.9993L26.1403 55.9993C23.8771 55.9993 22.0647 54.1232 22.1427 51.8614L22.3668 45.3621C22.4411 43.2079 24.209 41.5 26.3644 41.5L43 41.5",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82L38 41",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41L38 -1.19209e-06",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformatoareDeCurent2);
export default __webpack_public_path__ + "static/media/transformatoare_de_curent_2.a10e0e693699fb0ae902184da7b22f54.svg";
export { ForwardRef as ReactComponent };